import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { IapReconnectDialogComponent } from '@app/iap-reconnect-dialog/iap-reconnect-dialog.component';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '@app/shared/services/auth.service';

@Injectable()
export class IapInterceptor implements HttpInterceptor {

  constructor(public dialog: MatDialog, private authService: AuthService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.includes('i18n') || request.url.includes('/fraud/verifyToken')) {
      return next.handle(request)
    }

    return next.handle(request).pipe(
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse
          && err.status === 401
          && err.headers.get('x-goog-iap-generated-response')) {
            console.log("IAP ERROR")
          this.dialog.open(IapReconnectDialogComponent, {});
        }
        //console.log("throwing err :", err)
        return throwError(err);
      }));
  }
}
